import React from "react";
import { Overlay } from "components/generic/layout";
import initialLogo from "components/assets/img_avatar.png";
import { Avatar } from "components/generic/kit";
import Menu from "./Menu";
export default ({
  children,
  onSignOut,
  showMenu,
  handleClick,
  user: { avatar, first_name, last_name }
}) => (
  <Overlay
    right={
      <div className="pointer" onClick={handleClick}>
        <Avatar
          avatar={avatar || initialLogo}
          title={`${first_name} ${last_name}`}
        />
      </div>
    }
  >
    {showMenu && <Menu />}
    {children}
  </Overlay>
);



// WEBPACK FOOTER //
// ./src/components/common/insider/Overlay/View.js